export const getUserMe = (state) => {
    return state?.auth?.auth?.user
};
